import { Component, OnInit, Injector, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MensagemUtilService } from '../../../util/mensagemutil.service';
import { ToasterUtilService } from '../../../util/toaster-util.service';
import { UsuarioService } from '../../../service/usuario.service';
import { TipoAcesso } from '../../../util/enum/tipo-acesso.enum';
import { UtilService } from '../../../util/util.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SessaoUtil } from '../../../util/sessao-util';
import { FormGroup,FormBuilder } from '@angular/forms';
import { UsuarioAuxModel } from '../../../util/model/usuario-aux.model';
declare var $: any;
@Component({
  selector: 'app-listagem-usuario',
  templateUrl: './listagem-usuario.component.html',
  styleUrls: ['./listagem-usuario.component.scss'],
  providers: [UsuarioService]
})

@Injectable()
export class ListagemUsuarioComponent implements OnInit {

  entityForm: FormGroup;
  table: any = null;
  data: Array<any> = [];


// ******************TabelaDataTables********************** //

  constructor(
    private injector: Injector,
    private router: Router,
    private mensagemUtil: MensagemUtilService,
    private service: UsuarioService,
    private toasterUtil: ToasterUtilService,
    private spinnerService: Ng4LoadingSpinnerService,
    private sessao: SessaoUtil
  ) { }

  ngOnInit() {
    var self = this;
    this.montarTable();
   // this.retornaDados();
   $(document).ready(function () {
      $('table#table-listagem-usuario').on('click', 'button.btn-consultar', function(e){
        let id = $(this).data('idusuario');
        self.onConsulta(id);
      });
      $('table#table-listagem-usuario').on('click', 'button.btn-alterar', function(e){
        let id = $(this).data('idusuario');
        self.onEdit(id);
      });
      $('button#btn-insert').on('click', function(e){
        self.onInsere()                   ;
      });
    });
  }
  montarTable(){
    this.table = $('table#table-listagem-usuario').DataTable(this.configTable());
  }

  refreshTable(){
    this.table.destroy();
    setTimeout(() => this.montarTable(), 200);
  }

  onConsulta(id){
    this.router.navigate(['/usuarios/consultaUsuario', id]);
  }

  onEdit(id) {
    this.router.navigate(['/usuarios/editaUsuario', id]);
  }

  onInsere() {
    this.router.navigate(['/usuarios/adicionaUsuario']);
  }

  onChecked(id: number, value: boolean, checkbox) {
    this.service.atualizaAtivo(id, value).then(retorno => {
                                                if(retorno != undefined && retorno != value && checkbox != undefined){
                                                  $(checkbox).prop('checked', retorno);
                                                }
                                              }).catch(erro => {
                                                if(checkbox != undefined){
                                                  $(checkbox).prop('checked', !value);
                                                }
                                              });
  }

  configTable(){
    var self = this;

    return {
      retrieve: true,
      bAutoWidth: true,
      paging: true,
      searching: true,
      info: true,
      lengthChange: true,
      dom: $.ats._dataTableDom(),
      lengthMenu: [[10, 25, 50], [10, 25, 50]],
      order: [[0, 'asc'], [2, 'asc'], [1, 'asc']],
      sPaginationType: 'numbers',
      columnDefs: [{  targets: 0, data: 'id', className: 'text-center text-nowrap', width: 70,  render: function (data, type, row, meta) {
                      return $.ats._lpad(data, 6, '0');
                    }},
                   { targets: 1, data: 'nome'},
                   { targets: 2, data: 'login'},
                   { targets: 3, data: 'tipoAcesso', width:140, render: function (data, type, row, meta) {
                      return !UtilService.empty(data) ? TipoAcesso[data] : '';
                    }},
                   { targets: 4, data: 'ativo', render: function (data, type, row, meta) {
                      return data ? 'Sim' : 'Não';
                    }},
                   { targets: 5, data: 'id', className: 'text-center text-nowrap', orderable: false, width: 10, render: function (data, type, row, meta) {
                    return '<button type="button" data-idusuario="'+row.id+'"  title="Consultar" class="btn btn-xs btn-outline btn-default btn-consultar"><i class="fa fa-eye" aria-hidden="true"></i></button>'+
                           '<button type="button" data-idusuario="'+row.id+'"  title="Alterar" class="btn btn-xs btn-outline btn-info btn-alterar"><i class="fa fa-edit" aria-hidden="true"></i></button>';
                  }}],
      language: $.ats._dataTableLanguage('Digite aqui sua pesquisa...'),
      bServerSide: true,
      sAjaxSource: UtilService.getUrl() + '/usuarios/paginate',
      sServerMethod: "POST",
      fnServerData: function(sSource, aoData, fnCallback){
        $.ats._datatablesServerData(sSource, aoData, fnCallback, self.table, self.sessao.getToken().access_token, self.toasterUtil);
      },
      fnServerParams : function(aoData) {
        let usuarioAux : UsuarioAuxModel = new UsuarioAuxModel();
        usuarioAux.idUsuario = self.sessao.idUsuarioLogado;
        usuarioAux.isAdmin = self.sessao.isUsuarioAdministrador();
        aoData.push({'name' : 'parametrosAdicionais','value' : JSON.stringify(usuarioAux)});        
      }
    };                   
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/usuarios/listagem-usuario/listagem-usuario.component.ts